import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDkHbFBYq3mfSfUfqlpY7xa09z9GKsM19k",
  authDomain: "site-web-r2b-entreprises-c2d45.firebaseapp.com",
  projectId: "site-web-r2b-entreprises-c2d45",
  storageBucket: "site-web-r2b-entreprises-c2d45.firebasestorage.app",
  messagingSenderId: "171820877351",
  appId: "1:171820877351:web:8e469471a6fdee9cdef002"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
